{
  "ResourceModal": {
    "title": "Generuj PDF zasobu",
    "managerTitle": "Dostępne pola",
    "Instagram": "Instagram",
    "Twitter": "Twitter",
    "Behance": "Behance",
    "Youtube": "Youtube",
    "Vimeo": "Vimeo",
    "Website": "Strona internetowa",
    "Email": "E-mail",
    "Phone number": "Numer telefonu",
    "Location": "Lokalizacja",
    "Rate": "Ocena",
    "Tags": "Tagi",
    "Organization": "Organizacja",
    "Agent": "Agent",
    "Groups": "Grupy",
    "QR Code": "Kod QR",
    "Options": "Opcje"
  }
}
